var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1641 24C48.1641 37.2548 37.4189 48 24.1641 48C10.9092 48 0.164062 37.2548 0.164062 24C0.164062 10.7452 10.9092 0 24.1641 0C37.4189 0 48.1641 10.7452 48.1641 24Z",
    fill: "#CAD6E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6997 24.5578H22.6676V20.8423H23.6997C24.3017 20.8423 24.7718 20.9967 25.1101 21.3056C25.4541 21.6086 25.6261 22.0689 25.6261 22.6867V22.7045C25.6261 23.3163 25.4541 23.7796 25.1101 24.0944C24.7718 24.4033 24.3017 24.5578 23.6997 24.5578Z",
    fill: "#021922"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5926 12C13.6991 12 12.1641 13.535 12.1641 15.4286V32.5714C12.1641 34.465 13.6991 36 15.5926 36H32.7355C34.629 36 36.1641 34.465 36.1641 32.5714V15.4286C36.1641 13.535 34.629 12 32.7355 12H15.5926ZM24.5683 18H19.0212V30.8571H22.6676V27.3466H24.5683C25.5372 27.3466 26.3743 27.1595 27.0795 26.7853C27.7904 26.4051 28.338 25.8675 28.7221 25.1726C29.112 24.4776 29.3069 23.6549 29.3069 22.7045V22.6867C29.3069 21.7363 29.112 20.9106 28.7221 20.2097C28.338 19.5088 27.7904 18.9653 27.0795 18.5792C26.3743 18.1931 25.5372 18 24.5683 18Z",
    fill: "#021922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/Parking.0ee21406fb8d986f1d74b27770cab758.svg";
export { ForwardRef as ReactComponent };